import { createContext, useContext } from 'react';

export type ToastKind = 'info' | 'success' | 'error';
export interface ToastMessage {
  id: number;
  kind: ToastKind;
  text: string;
}

export interface ToastApi {
  push: (kind: ToastKind, text: string) => void;
  toasts: ToastMessage[];
  dismiss: (id: number) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
  return ctx;
}
